// extracted by mini-css-extract-plugin
export default {"msgM":"_038cf1a7c9"};